export default __webpack_public_path__ + "static/media/Checkmark.6b74dd82.svg";